import React, { FC, SyntheticEvent, useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UserRole } from "@green0meter/api-client";
import { useNavigate, useParams } from "react-router-dom";

import { PageTitle, Tabs } from "@components/common";
import {
  EntitiesManagement,
  OrganizationSettings,
  UsersManagement,
  OrgChart,
} from "@components/main/organization";
import { useUserStore } from "@store/user";
import { Card, CardContent, Divider } from "@components/base";
import { useUpdateCompany } from "@api";
import { TabItem } from "@components/common/Tabs";

type Tab = "users" | "entities" | "org-chart" | "settings" | "glossary";

const OrganizationPage: FC = () => {
  const { user } = useUserStore();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tab } = useParams<{ tab: Tab }>();
  const [activeTab, setActiveTab] = useState<Tab>(tab || "users");
  const { updateCompanyEnabled } = useUpdateCompany(user);

  const tabs: TabItem<Tab>[] = [
    {
      path: "users",
      title: t("organization.tabs.users.title"),
      hide:
        user?.role !== UserRole.Owner &&
        user?.role !== UserRole.Manager &&
        user?.role !== UserRole.Admin,
    },
    {
      path: "entities",
      title: t("organization.tabs.entities.title"),
      hide: !updateCompanyEnabled,
    },
    {
      path: "org-chart",
      title: t("organization.tabs.orgChart.title"),
    },
    {
      path: "settings",
      title: t("organization.tabs.settings.title"),
    },
    // { path: "glossary", title: t("organization.tabs.glossary.title") },
  ];

  const handleTabChange = (event: SyntheticEvent, value: Tab): void => {
    navigate(`/organization/${value}`);
  };

  const title = t("organization.title");

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    }
  }, [tab]);

  return (
    <Card>
      <CardContent>
        <Stack mb={6} height="100%" flexDirection="column">
          <Box>
            <Box mb={3}>
              <PageTitle title={title} />
              <Typography variant="subtitle1">{title}</Typography>
            </Box>
            <Tabs<Tab>
              tabs={tabs}
              activeTab={activeTab}
              onChange={handleTabChange}
            />
            <Divider />
          </Box>
          {activeTab === "users" && <UsersManagement />}
          {activeTab === "entities" && <EntitiesManagement />}
          {activeTab === "org-chart" && <OrgChart />}
          {activeTab === "settings" && <OrganizationSettings />}
          {/*{activeTab === "glossary" && <GlossaryManagement />}*/}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default OrganizationPage;
